import { useQuery } from "@apollo/client";
import {
  getTGPSubscriptionGQL,
  UserSubscriptionStatus,
  Query,
} from "@onmo/graphql/graphql";
import { useMemo } from "react";

export function useTgpSubscriptions(enabled = true) {
  const { data, refetch, error } = useQuery<Query>(getTGPSubscriptionGQL, {
    fetchPolicy: "cache-and-network",
    skip: !enabled,
  });

  const subscriptions = useMemo(
    () =>
      (data?.me?.subscriptions ?? []).filter(
        (sub) =>
          sub?.status === UserSubscriptionStatus.Subscribed && !!sub.product,
      ),
    [data?.me?.subscriptions],
  );

  return {
    subscriptions,
    refetch,
    error,
  };
}